import SoloFind from '../SoloFind';
import SoloPuzzleInfo from '../SoloPuzzleInfo';
import GameContainer from '../GameContainer';
import SoloResults from '../SoloResults';
import DuelFind from '../DuelFind';
import DuelPuzzleInfo from '../DuelPuzzleInfo';
import DuelResults from '../DuelResults';
import MirrorFind from '../MirrorFind';
import MirrorPuzzleInfo from '../MirrorPuzzleInfo';
import MirrorResults from '../MirrorResults';
import TournamentFind from '../TournamentFind';
import TournamentPuzzleInfo from '../TournamentPuzzleInfo';
import TournamentResults from '../TournamentResults';
import CreateFind from '../CreateFind';
import CreateResults from '../CreateResults';

// Map: mode -> status -> component
export const MODE_STATUS_COMPONENTS = {
  solo: {
    none: SoloFind,
    ready: SoloPuzzleInfo,
    active: GameContainer,
    solved: SoloResults,
  },
  duel: {
    none: DuelFind,
    ready: DuelPuzzleInfo,
    active: GameContainer,
    solved: DuelResults,
  },
  mirror: {
    none: MirrorFind,
    ready: MirrorPuzzleInfo,
    active: GameContainer,
    solved: MirrorResults,
  },
  tournament: {
    none: TournamentFind,
    ready: TournamentPuzzleInfo,
    active: GameContainer,
    solved: TournamentResults,
  },
  create: {
    none: CreateFind,
    active: GameContainer,
    submitted: CreateResults
  }
};